import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function SwapIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M7.5 15h12a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.75H9a.75.75 0 0 0-.75.75v.75" stroke="currentColor"
            strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75 12.75 7.5 15l2.25 2.25" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round"
            strokeLinejoin="round" />
      <path d="M16.5 9h-12a.75.75 0 0 0-.75.75v9.75a.75.75 0 0 0 .75.75H15a.75.75 0 0 0 .75-.75v-.75"
            stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.25 11.25 16.5 9l-2.25-2.25" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round"
            strokeLinejoin="round" />
    </BaseIcon>
  )
}
